import { Alert } from "@mui/material";
import React from "react";
import { useAnalyticsStore } from "./AnalyticsStore/analyticsStore";

export const AnalyticsAlerts = () => {
  const { alertState, setAlertState } = useAnalyticsStore();

  return (
    <div>
      {alertState.dateTooFar && (
        <Alert
          severity="warning"
          onClose={() => {
            setAlertState({ ...alertState, dateTooFar: false });
          }}
        >
          Only data from 2 months or less can be filtered. Please choose a date
          within the past 2 months.
        </Alert>
      )}
      {alertState.startAfterEnd && (
        <Alert
          severity="warning"
          onClose={() => {
            setAlertState({ ...alertState, startAfterEnd: false });
          }}
        >
          Please choose a start date that is before your selected end date.
        </Alert>
      )}
      {alertState.endBeforeStart && (
        <Alert
          severity="warning"
          onClose={() => {
            setAlertState({ ...alertState, endBeforeStart: false });
          }}
        >
          Please choose an end date that is after, or the same as, your selected
          start date.
        </Alert>
      )}
    </div>
  );
};
